import { Box, Icon, MaterialTextInput, MaterialTextInputProps } from '@jfs/ui-new'
import { FC, useState } from 'react'
import { TollTip } from './TollTip'

interface Props extends MaterialTextInputProps {
  infoText?: string
  infoIconColor?: any
}

const TextInputToolTip: FC<Props> = ({ infoText = '', infoIconColor = 'PRIMARY', ...restProps }: Props) => {
  const [toolTipVisibility, setToolTipVisibility] = useState(false)

  return (
    <>
      <MaterialTextInput
        rightComponent={
          infoText !== '' && (
            <Box
              underlayColor={'TRANSPARENT'}
              onPress={() => setToolTipVisibility(true)}
              onHover={(value: boolean) => {
                setToolTipVisibility(value)
              }}>
              <Icon color={infoIconColor} id="INFO" size={19} />
            </Box>
          )
        }
        {...restProps}
      />
      <TollTip visible={toolTipVisibility} msg={infoText} />
    </>
  )
}

export { TextInputToolTip }
